/* Brouillon → approbation → envoi — AI-03 (Bible §51 · locked #18).
   New review → draft → merchant edit/approve → sent → provider result.
   Auto-send stays a gated future toggle: nothing leaves without a person. */
import { Button, Card, ErrorState, Note } from '@/ui'
import { useDraft } from './api'
import { Chargement, Retour } from './parts'

export default function Brouillon() {
  const { data, isPending, isError, refetch } = useDraft()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger le brouillon."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 640 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Brouillon — {data.reviewLabel}</h2>

      <Card>
        <p className="t-body" style={{ fontSize: 13 }}>{data.body}</p>
        <p className="f-help" style={{ marginTop: 8 }}>{data.signature}</p>
      </Card>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button size="sm" variant="quiet">Modifier</Button>
        <Button size="sm" variant="quiet">Régénérer</Button>
        <Button size="sm" variant="primary">Approuver et envoyer</Button>
      </div>

      <Note tone="candour">
        La chaleur s’adapte, les faits jamais&nbsp;: aucun détail de visite, promesse,
        personne ou geste commercial inventé. Journal complet&nbsp;: avis source, brouillon,
        modifications, approbateur, envoi, résultat Google.
      </Note>
    </div>
  )
}
